// extracted by mini-css-extract-plugin
export default {"cls1":"AuthorHeader-cls1___197aa20f256cc821968","cls2":"AuthorHeader-cls2___8b31adb309b8c6625ee AuthorHeader-cls1___197aa20f256cc821968"};